<template>
  <v-container>
    <helmet-provider>
      <div>
        <helmet>
          <title>Weedcraft Inc 日本語化 - 日本語化ファイル置き場 -</title>
          <meta name='description' content='Steamで配信中のシミュレーションゲーム、"Weedcraft Inc" の日本語化に関するページです。'>
          <meta property='og:title' content='日本語化ファイル置き場'/>
          <meta property='og:description' content='Steamで配信中のシミュレーションゲーム、"Weedcraft Inc" の日本語化に関するページです。'/>
          <meta property='og:image' content='https://storage.googleapis.com/porte-parapluies.appspot.com/Weedcraft/001s.webp'/>
          <meta property='og:url' content='https://porte-parapluies.web.app/games/weedcraft/'/>
          <meta property='og:type' content='website'/>
        </helmet>
      </div>
    </helmet-provider>
    <page-title 
      title='Weedcraft Inc 日本語化'
      link='https://porte-parapluies.web.app/games/weedcraft/'/>
    <game-info 
      gameName='Weedcraft Inc' 
      gameLink='https://store.steampowered.com/app/622720/Weedcraft_Inc/' 
      makerName='Vile Monarch' 
      makerLink='https://vilemonarch.com/'/>
    <page-contents 
      title="ゲームの内容"
      :contents=contents />
    <page-contents
      title="導入方法"
      :contents=guides />
    <page-contents
      :contents=alert />
    <game-image 
      title="日本語化Mod適用後のイメージ"
      path="Weedcraft"
      :images=images />
  </v-container>
</template>

<script>
import { HelmetProvider, Helmet } from "@jnields/vue-helmet";

import PageTitle from '@/components/PageTitle.vue'
import GameInfo from '@/components/GameInfo.vue'
import PageContents from '@/components/PageContents.vue'
import GameImage from '@/components/GameImage.vue'

export default {
  components: {
    PageTitle,
    GameInfo,
    PageContents,
    GameImage,
    HelmetProvider, 
    Helmet
  },
  data(){
    return{
      contents:[
        'Weedcraft Incは、大麻を栽培、販売し、成りあがっていくシミュレーションゲームです。\
        初めは自分で水やり、剪定をしながら大麻を栽培し、手動で販売してお金を稼ぎますが、従業員を雇い作業を自動化して事業を拡大していきます。\
        栽培、販売に関しても、初めは違法なため、警察の目を逃れながら行う必要がありますが、ライセンスを取得して、合法的に行うこともできます。\
        品種ごとに栽培に適した条件を探ったり、新たな品種を開発したり、警察官にお願いして違法行為を見逃してもらったり、\
        広告を出して自分の品種の評判を上げたり、政治家に働きかけて法案を優位に変更したり、あらゆる手を使って事業を拡大していくことになります。\
        3つの基本シナリオと、条件を設定し一定期間内でのスコアを競い合うカスタムシナリオがあります。'
      ],
      alert:[
        '・機械翻訳ベースなのと、会話文が大半なため、微妙に意味が通じない部分が多々あります。',
        '・日本語にすると文章が長くなり、表示エリアをはみ出している箇所があります。',
        '・シナリオ名、チーム名、依頼名などの一部の固有名詞を除いてほぼ翻訳済みのはずです。',
        '・ゲームの背景上、下品だったり差別的だったりする単語が出てくることがありますが、ゲーム上の表現であり開発者や翻訳者の思想や信条をあらわすものではありません。'
        ],
      guides:[
        '日本語化ModはGoogleドライブに置いてあります。<a href="https://drive.google.com/drive/folders/11NXc_Tkqpgk17ywHqNh4XNOEqLnt8uB9?usp=sharing" target="_blank">こちら</a>からダウンロードして中のreadme.txtの手順に従って導入してください。',
        '当ModはBepInEXを使用しています。BepInEx導入については、<a href="/tools/bepinex" >BepInExの導入</a>のページや他のサイトを参照してください。',
        'Modを導入すると、英語に上書きする形で日本語が表示されます。'
      ],
      images:[
        {
          alt:'タイトル画面',
          overlay: false
        },
        {
          alt:'会話シーン',
          overlay: false
        },
        {
          alt:'栽培室',
          overlay: false
        },
        {
          alt:'収支画面',
          overlay: false
        }
      ],
    }
  }
};
</script>
